import script from "./CMI00200.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMI00200.vue?vue&type=script&setup=true&lang=ts"

import "./CMI00200.vue?vue&type=style&index=0&id=22dc5717&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22dc5717"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QBtn});
